import styled from 'styled-components'

const Image = styled('img')`
  width: ${({ size }) => (size === 'large' ? '112px' : '88px')};
  height: ${({ size }) => (size === 'large' ? '113px' : '92px')};
  border-radius: ${({ size }) => (size === 'large' ? '4px' : '6.8px')};
`

export default Image
